import { render } from "./Customer.vue?vue&type=template&id=c9c7c756&scoped=true"
import script from "../js/customer.js?vue&type=script&lang=js"
export * from "../js/customer.js?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=c9c7c756&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c7c756"]])

export default __exports__